import type { GetFundAdminServicesQuery } from "#graphql/supergraphTypes";

type FundAdminRequestedServiceObjects = NonNullable<
  GetFundAdminServicesQuery["fundAdminServices"]
>["edges"][number]["node"]["objects"];

export type MoneyType = {
  amount?: number;
  currency?: string;
  precision?: number;
};

export const hasSingleUserObject = (objects: FundAdminRequestedServiceObjects) =>
  objects.length === 1 && objects[0].objectValue.__typename === "UserObjectType";

export const hasObjectsWithAmounts = (objects: FundAdminRequestedServiceObjects) =>
  objects.some((object) => {
    if (!object.objectDetails || object.objectDetails === "{}") {
      return false;
    }
    try {
      const parsed = JSON.parse(object.objectDetails) as { amount?: unknown };
      return Boolean(parsed.amount);
    } catch {
      return false;
    }
  });

export const formatMoney = (money: MoneyType | null | undefined): string => {
  if (!money || money.amount === undefined) return "--";
  const amount = money.amount / Math.pow(10, money.precision || 2);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: money.currency || "USD",
  }).format(amount);
};

export const pluralizeEntity = (count: number): string => (count === 1 ? "entity" : "entities");
